// extracted by mini-css-extract-plugin
module.exports = {"Error":"LoadingAreaHandler_Error__3VrvO","ErrorIcon":"LoadingAreaHandler_ErrorIcon__2pban"};